import { BarChart3, Users, TrendingUp, Star, UserX } from "lucide-react";

const gradeColor = (g) => {
  if (!g) return "#71717a";
  if (g.startsWith("A")) return "#34d399";
  if (g.startsWith("B")) return "#60a5fa";
  if (g.startsWith("C")) return "#fbbf24";
  return "#f87171";
};

export default function MarketersView({ data }) {
  return (
    <div className="marketers-section" data-testid="marketers-section">
      <h2 className="section-title"><BarChart3 size={18} color="#ff4500" /> Marketer Performance</h2>
      {data.length === 0 ? (
        <div className="empty-state"><Users size={48} /><div className="empty-text">No marketers yet</div></div>
      ) : (
        <div className="marketer-cards-grid" data-testid="marketer-cards-grid">
          {data.map(m => (
            <div key={m.marketer} className={`marketer-card ${m.inactive ? 'inactive-card' : ''}`} data-testid={`marketer-card-${m.marketer}`}>
              <div className="marketer-card-header">
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span className="marketer-card-name">{m.marketer}</span>
                  {m.inactive && (
                    <span data-testid={`inactive-tag-${m.marketer}`} style={{
                      fontSize: 10, fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em',
                      padding: '2px 6px', borderRadius: 4,
                      background: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: '1px solid rgba(239,68,68,0.2)',
                    }}>
                      <UserX size={10} style={{ display: 'inline', marginRight: 3 }} />Inactive
                    </span>
                  )}
                </div>
                <span className="marketer-card-total">{m.total} entries</span>
              </div>
              <div className="marketer-metrics">
                <div className="metric-item">
                  <div className="metric-value" style={{color:'var(--live-green)'}}>{m.live}</div>
                  <div className="metric-label">Live</div>
                </div>
                <div className="metric-item">
                  <div className="metric-value" style={{color:'var(--deleted-red)'}}>{m.deleted}</div>
                  <div className="metric-label">Deleted</div>
                </div>
                <div className="metric-item">
                  <div className="metric-value" style={{color:'var(--live-green)'}}>{m.success_rate}%</div>
                  <div className="metric-label">Success</div>
                </div>
              </div>
              {/* Grade row */}
              {m.avg_grade && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8, padding: '6px 10px', borderRadius: 6, background: `${gradeColor(m.avg_grade)}08`, border: `1px solid ${gradeColor(m.avg_grade)}20` }}>
                  <Star size={14} color={gradeColor(m.avg_grade)} />
                  <span style={{ fontFamily: 'JetBrains Mono', fontWeight: 700, fontSize: 16, color: gradeColor(m.avg_grade) }}>{m.avg_grade}</span>
                  <span style={{ fontSize: 12, color: '#a1a1aa' }}>avg ({m.avg_grade_score}/100 from {m.graded_count} graded)</span>
                </div>
              )}
              <div className="marketer-stats-row">
                <div className="mini-stat"><span className="mini-stat-dot accounts"></span>{m.accounts} accounts</div>
                <div className="mini-stat"><span className="mini-stat-dot subreddits"></span>{m.subreddits} subreddits</div>
                {m.avg_rank && <div className="mini-stat"><span className="mini-stat-dot rank"></span>Avg #{m.avg_rank}</div>}
              </div>
              <div style={{marginTop:10,fontSize:13,color:'#71717a'}}>
                <TrendingUp size={13} style={{display:'inline',marginRight:4}} />{m.upvotes} total upvotes
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
